import {
  dispatchErrorMessage,
  loadingToast,
  updateToast,
} from "../utils/toast";
import { deleteCall, getCall, postCall, putCall } from "../utils/calls";

export const getAdminUser = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/admin/" + bot_id);
  if (res[0]) {
    return res[0];
  } else return null;
};

export const deleteAdminUser = async (user) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await deleteCall("/admin/" + bot_id + "/" + user.user_id);
  if (res[0]) {
    updateToast(id, "success", "Usuario borrado correctamente");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al Borrar");
    return null;
  }
};

export const inviteNewAdminUser = async (email) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  let data = {
    email: email,
  };
  const res = await postCall("/admin/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Usuario invitado correctamente");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al invitar usuario");
    return null;
  }
};

export const resendInvitionAdminUser = async (email) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  let data = {
    email: email,
  };
  const res = await postCall("/admin/resend/invitation/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Usuario reinvitado correctamente");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al reinvitar usuario");
    return null;
  }
};

export const completeRegister = async (idU, data) => {
  // const bot_id = localStorage.getItem("bot");
  const id = loadingToast();

  const res = await postCall("/admin/accept/" + idU, data);
  if (res[0]) {
    updateToast(id, "success", "Registro completado correctamente");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al completar el registro");
    return null;
  }
};

export const saveEditRoleContact = async (user) => {
  // 2 Administrador
  // 3 Editor
  // 4 Operador
  // 5 Coordinador
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const data = {
    role_id:
      user.role === "Administrador"
        ? 2
        : user.role === "Editor"
        ? 3
        : user.role === "Operador"
        ? 4
        : user.role === "Coordinador" && 5,
  };
  const res = await putCall(
    "/admin/toggle/" + bot_id + "/" + user.user_id,
    data
  );
  if (res[0]) {
    updateToast(id, "success", "Rol editado correctamente");
    return res[0];
  } else {
    updateToast(id, "error", "Error al editar el rol");
    return null;
  }
};
export const saveEditUserbyAdmin = async (user) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/admin/edit/" + bot_id + "/" + user.user_id, user);
  if (res[0]) {
    updateToast(id, "success", "Usuario editado correctamente");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al editar el usuario");
    return null;
  }
};
